import React from 'react'

export function FormField({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <div className="flexbox flexbox-column flexbox-gap-8 flexbox-grow min-width-zero">
      <span className="font-size-7 font-weight-semibold">{label}</span>
      {children}
    </div>
  )
}
